import {i18n} from '@dms/i18n';

import {useVehicleFormContext} from '../hooks/useVehicleFormContext';
import {Field} from './primitives/Field';

export function DriveChips() {
  const {catalogueApi} = useVehicleFormContext();
  return (
    <Field
      type="chips"
      name="drive"
      label={i18n.t('entity.vehicle.labels.drive')}
      options={catalogueApi?.driveOptions ?? []}
      isDeselectable
    />
  );
}
